<script setup>
import { computed, watch } from 'vue';
import CardLayout from 'dashboard/components-next/CardLayout.vue';
import { messageStamp } from 'shared/helpers/timeHelper';

const props = defineProps({
  id: {
    type: Number,
    default: 0,
  },
  number: {
    type: String,
    default: '',
  },
  amount: {
    type: String,
    default: '',
  },
  status: {
    type: Number,
    default: 1,
  },
  createdAt: {
    type: Number,
    default: 0,
  },
  currencySymbol: {
    type: String,
    default: null,
  },
  canWithdraw: {
    type: Boolean,
    default: false,
  },
});

const statusMap = {
  1: { text: 'pending', color: 'text-orange-600 bg-orange-100' },
  2: { text: 'success', color: 'text-teal-600 bg-teal-100' },
  3: { text: 'failed', color: 'text-red-600 bg-red-100' },
  4: { text: 'success', color: 'text-teal-600 bg-teal-100' },
};

// 计算属性：状态颜色
const statusTextColor = computed(() => {
  return statusMap[props.status]?.color;
});

// 计算属性：状态文字
const statusText = computed(() => {
  return statusMap[props.status]?.text;
});

// 格式化日期
const formattedDate = computed(() => {
  return messageStamp(props.createdAt, 'LLL d, h:mm a');
});

// 点击事件，透传父组件
const emit = defineEmits(['details', 'withdraw']);
const handleClick = () => {
  emit('details', {
    id: props.id,
    number: props.number,
    amount: props.amount,
    status: props.status,
    createdAt: props.createdAt,
  });
};

const handleWithdraw = () => {
  emit('withdraw');
};
</script>

<template>
  <!-- 使用 CardLayout 作为卡片布局 -->
  <CardLayout layout="row">
    <!-- 左侧内容 -->
    <div class="flex flex-col gap-3 min-w-0 flex-1 OrderCard">
      <!-- Order ID & Status -->
      <div class="flex justify-between items-center w-full">
        <woot-button
          color-scheme="success"
          variant="link"
          @click="handleClick"
        >
          {{ number }}
        </woot-button>
        <span
          class="inline-flex items-center text-xs font-medium px-3 py-1 rounded-full"
          :class="statusTextColor"
        >
          {{ statusText }}
        </span>
      </div>

      <!-- Amount & Created At -->
      <div class="flex justify-between items-center w-full gap-2">
        <span class="text-sm font-medium text-gray-600">
          Amount: <strong>{{ currencySymbol }} {{ amount }}</strong>
        </span>
        <span class="text-xs text-gray-500">
          {{ formattedDate }}
        </span>
      </div>

      <div v-if="canWithdraw" class="relative flex justify-end w-full gap-2">
        <woot-button color-scheme="primary" size="tiny" @click="handleWithdraw">
          Withdraw
        </woot-button>
      </div>
    </div>
  </CardLayout>
</template>
